import { z } from 'zod';
export const competitionCodeSchema = z.enum([
    'world_cup',
    'euro',
    'copa_america',
    'nations_league',
    'world_cup_qualifier',
    'friendlies',
]);
export const competitionTierSchema = z.enum(['A', 'B', 'C', 'D']);
export const qualityScoreSchema = z.number().min(0).max(1);
export const coverageRateSchema = z.number().min(0).max(1);
export const coverageVerdictSchema = z.enum(['pass', 'partial', 'fail']);
